/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddMealRequest } from '../model';
/**
 * AdminMenuItemControllerApi - axios parameter creator
 * @export
 */
export const AdminMenuItemControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} menuItemId 
         * @param {AddMealRequest} addMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMealToMenuItem: async (menuItemId: string, addMealRequest: AddMealRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuItemId' is not null or undefined
            assertParamExists('addMealToMenuItem', 'menuItemId', menuItemId)
            // verify required parameter 'addMealRequest' is not null or undefined
            assertParamExists('addMealToMenuItem', 'addMealRequest', addMealRequest)
            const localVarPath = `/admin/menu-items/{menuItemId}/meals`
                .replace(`{${"menuItemId"}}`, encodeURIComponent(String(menuItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMealRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} menuItemId 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMealFromMenuItem: async (menuItemId: string, mealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuItemId' is not null or undefined
            assertParamExists('deleteMealFromMenuItem', 'menuItemId', menuItemId)
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('deleteMealFromMenuItem', 'mealId', mealId)
            const localVarPath = `/admin/menu-items/{menuItemId}/meals/{mealId}`
                .replace(`{${"menuItemId"}}`, encodeURIComponent(String(menuItemId)))
                .replace(`{${"mealId"}}`, encodeURIComponent(String(mealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMenuItemControllerApi - functional programming interface
 * @export
 */
export const AdminMenuItemControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMenuItemControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} menuItemId 
         * @param {AddMealRequest} addMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMealToMenuItem(menuItemId: string, addMealRequest: AddMealRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMealToMenuItem(menuItemId, addMealRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} menuItemId 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMealFromMenuItem(menuItemId: string, mealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMealFromMenuItem(menuItemId, mealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMenuItemControllerApi - factory interface
 * @export
 */
export const AdminMenuItemControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMenuItemControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} menuItemId 
         * @param {AddMealRequest} addMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMealToMenuItem(menuItemId: string, addMealRequest: AddMealRequest, options?: any): AxiosPromise<void> {
            return localVarFp.addMealToMenuItem(menuItemId, addMealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} menuItemId 
         * @param {string} mealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMealFromMenuItem(menuItemId: string, mealId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMealFromMenuItem(menuItemId, mealId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMenuItemControllerApi - object-oriented interface
 * @export
 * @class AdminMenuItemControllerApi
 * @extends {BaseAPI}
 */
export class AdminMenuItemControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} menuItemId 
     * @param {AddMealRequest} addMealRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMenuItemControllerApi
     */
    public addMealToMenuItem(menuItemId: string, addMealRequest: AddMealRequest, options?: AxiosRequestConfig) {
        return AdminMenuItemControllerApiFp(this.configuration).addMealToMenuItem(menuItemId, addMealRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} menuItemId 
     * @param {string} mealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMenuItemControllerApi
     */
    public deleteMealFromMenuItem(menuItemId: string, mealId: string, options?: AxiosRequestConfig) {
        return AdminMenuItemControllerApiFp(this.configuration).deleteMealFromMenuItem(menuItemId, mealId, options).then((request) => request(this.axios, this.basePath));
    }
}

